import type { Agency, Device, Merchant, MerchantStore } from '../../../../common/types';
import AddApiConfig from '../../../sticky-config/components/AddApiConfig';
import { AiOutlineEdit } from 'react-icons/ai';
import EditApiConfigV2 from '../../../sticky-config/components/EditApiConfig';
import NoDataContainer from './NoDataContainer';
import type { OwnerType } from '../../../../common/constants';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetApiConfigByOwnerQuery } from '../../../sticky-config/sticky-config.api-slice';
import { useState } from 'react';
import ViewContainer from './ViewContainer';

interface IProps {
  ownerType: OwnerType;
  ownerEntity: Agency | Merchant | MerchantStore | Device;
}

const DataContainer: React.FC<IProps> = ({ ownerType, ownerEntity }) => {
  const { data: apiConfig } = useGetApiConfigByOwnerQuery(
    ownerEntity !== null ? { ownerType, ownerId: ownerEntity.id } : skipToken
  );
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);

  const toggleAddModal = (): void => {
    setOpenAddModal(!openAddModal);
  };

  const toggleEditModal = (): void => {
    setOpenEditModal(!openEditModal);
  };

  return (
    <div className="min-h-[200px]">
      <div className="h-full flex flex-col">
        <div className="w-full border-b-2 pb-1 flex justify-between items-center">
          <span className="font-xl font-bold text-xl">Default Api Config</span>
          {apiConfig != null && (
            <div
              onClick={toggleEditModal}
              className="flex py-2 text-gray-50 px-2 bg-[#1D8A43] text-center rounded-lg space-between  justify-center items-center"
            >
              <AiOutlineEdit size={20} />
              <button className="text-sm px-2">Edit</button>
            </div>
          )}
        </div>
        {apiConfig != null && (
          <EditApiConfigV2 isOpen={openEditModal} toggleEditModal={toggleEditModal} item={apiConfig} />
        )}
        {apiConfig == null && (
          <AddApiConfig
            isOpen={openAddModal}
            toggleModal={toggleAddModal}
            ownerEntityType={ownerType}
            ownerEntity={ownerEntity}
          />
        )}
        {apiConfig == null && <NoDataContainer toggleModal={toggleAddModal} storeId={ownerEntity.id} />}
        {apiConfig != null && <ViewContainer apiConfig={apiConfig} />}
      </div>
    </div>
  );
};

export default DataContainer;
